import React, { createContext, useState, useEffect } from 'react';
import { auth } from '../config/firebase'; // Import the auth instance from firebase.js

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const idTokenResult = await user.getIdTokenResult();
        setUser(user);
        setIsAdmin(idTokenResult.claims.admin || false);
      } else {
        setUser(null);
        setIsAdmin(false);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <UserContext.Provider value={{ user, isAdmin, setUser, setIsAdmin }}>
      {children}
    </UserContext.Provider>
  );
};